import { render } from "./TaggedPromoButton.vue?vue&type=template&id=167e2b2c&lang=pug"
import script from "./TaggedPromoButton.vue?vue&type=script&lang=js"
export * from "./TaggedPromoButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__